import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ArchiveService } from "../../services/archive.service";
import { DinamicData, Cell } from "../../models/dinamic-data";
import { Methods } from "../../shared/methods";
import swal from "sweetalert2";

@Component({
  selector: "app-archive",
  templateUrl: "./archive.component.html",
  styleUrls: ["./archive.component.css"],
})
export class ArchiveComponent implements OnInit {
  public mtds: Methods = new Methods();
  public loading = false;
  public bulk: Array<any> = [];

  public data: DinamicData = new DinamicData([
    "check",
    "ID",
    "Type",
    "PO Number",
    "Created Date",
    "Actions",
  ]);

  constructor(private _router: Router, private _service: ArchiveService) {}

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.loading = true;
    this.bulk = [];
    this.data.rows = [];
    this._service.getFolders().subscribe(
      (r) => {
        console.log(r);

        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          const actionButtons = [
            { icon: "remove_red_eye", action: "Show", color: "info" },
            // { icon: 'delete_outline', action: 'Remove', color: 'danger' }
          ];

          for (let element of r.data) {
            this.data.rows.push([
              new Cell(element.id, { type: "checkbox" }),
              new Cell(element.id),
              new Cell("", { icon: "folder" }),
              new Cell(element.name),
              new Cell(
                element.createdAt != null
                  ? this.mtds.getFecha(
                      new Date(element.createdAt.timestamp * 1000),
                      "MM/dd/yyyy h:mm:ss"
                    )
                  : null
              ),
              new Cell(actionButtons, { type: "actions" }),
            ]);
          }
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.loading = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loading = false;
      }
    );
  }

  action(e) {
    console.log(e);
    switch (e.action) {
      case "Show":
        this._router.navigate(["/tables/listfiles", e.id]);
        break;
      default:
        break;
    }
  }

  unarchive() {
    swal.fire({
      title: "",
      text: "Are you sure to unarchive selected folders?",
  
      showCancelButton: true,
      buttonsStyling: false,
  
      customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-default',
            },
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Continue",
    }).then((result) => {
      if (result.value) {
        console.log(this.bulk);
        const bulk = this.bulk.map((element) => {
          //return element[0].value;
          return element;
        });

        this._service.archiveBulk(bulk, "unarchived").subscribe((r) => {
          console.log(r);

          if (r.code === 400 && r.msg === "Authorization not valid") {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else if (r.status === "success") {
            this.getData();
            swal.fire({
              
              title: "Successfully unarchived folders!",
              text: "",
              buttonsStyling: false,
               customClass:{
    confirmButton: 'btn btn-success'
            },
            });
          } else {
            this.mtds.notifyError(r.msg, r.code);
          }
        });
      }
    });
  }
}
